<template>
  <v-container tag="section">
    <material-wizard
      v-model="tab"
      :title="title"
      subtitle="Preencha as Informações para gerar sua simulação do laudo express."
      :availableSteps="tabsLiberadas"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      :wizzardMixinsOn="true"
      @click:next="nextStep()"
      @click:prev="prevStep()"
    >
      <wizard-tabs ref="wizzardTabsREF" :tab="tab" @step-observer="updateTabStatus($event)" @update:tab="tab = $event" />
    </material-wizard>
  </v-container>
</template>

<script>
  import SimulacoesLaudosIncrementaisService from '@/services/SimulacoesLaudosIncrementaisService';
  import wizardMixins from '@/mixins/wizardMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      MaterialWizard: () => import('@/components/base/MaterialWizard.vue'),
      WizardTabs: () => import('@/components/simulacoesLaudosIncrementais/WizardTabs.vue')
    },
    mixins: [wizardMixins, dateFormatterMixins, tourMixins],

    data: () => ({
      tabs: ['Base Contábil', 'Banco de Preços', '% De Saneamento'],
      loading: false
    }),

    computed: {
      title() {
        return this.$route.params.id ? `Editando Simulação do Laudo Express` : 'Adicionar Nova Simulação do Laudo Express';
      },

      origemDadosAis: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.origemDadosAis;
        }
      },

      origemDadosBancoPrecos: {
        get() {
          return this.$store.state.simulacaoLaudoIncremental.origemDadosBancoPrecos;
        }
      },

      arrPrimeiraTabTour() {
        let tour = [
          {
            element: '#nome-simulacao',
            intro: 'Aqui você deverá inserir um nome para sua Simulação de Laudo Express.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#possui-obra-simulacao',
            intro: 'Aqui você deverá informar se sua base contábil possui obra.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#possui-material-simulacao',
            intro: 'Aqui você deverá informar se sua base contábil possui material.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          // {
          //   element: '#origem-ais-simulacao',
          //   intro: 'Aqui você deverá escolher a origem de sua base contábil.',
          //   scrollTo: "tooltip",
          //   position: 'right'
          // },
          {
            element: '#database-ais-simulacao',
            intro: 'Aqui você deverá inserir a data base da base contábil.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#data-simulacao-laudo',
            intro: 'Aqui você deverá inserir a data base de Simulação do Laudo Express.',
            scrollTo: 'tooltip',
            position: 'right'
          }
        ];

        let typeTour = this.$route.params.id ? this.origemDadosAis : 'AIS';
        if (typeTour == 'AIS') {
          tour.push({
            element: '#data-imobilizacao-simulacao',
            intro: 'Aqui você deverá inserir o intervalo de data de imobilização da base contábil.',
            scrollTo: 'tooltip',
            position: 'right'
          });
        } else if (typeTour == 'CSV') {
          // tour.push({
          //   element: "#csv-simulacao-li-first-tab",
          //   intro: "Aqui você deverá selecionar um arquivo csv para compor a base contábil e as configurações do arquivo (delimitador, invólucro, escape e mapeamento).",
          //   scrollTo: "tooltip",
          //   position: "top"
          // });
        } else {
          // tour.push({
          //   element: "#conciliacao-simulacao-li",
          //   intro: "Aqui você deverá selecionar uma conciliação para compar a base contábil.",
          //   scrollTo: "tooltip",
          //   position: "top"
          // });
        }

        return tour;
      },

      arrSegundaTabTour() {
        let tour = [
          {
            element: '#origem-banco-precos-simulacao',
            intro: 'Aqui você deverá escolher a origem de sua base de banco de preços.',
            scrollTo: 'tooltip',
            position: 'right'
          }
        ];

        let typeTour = this.$route.params.id ? this.origemDadosBancoPrecos : 'CALCULO';
        if (typeTour == 'CALCULO') {
          tour.push({
            element: '#calculo-banco-precos-simulacao',
            intro: 'Aqui você deverá selecionar um cálculo para compar o banco de preços.',
            scrollTo: 'tooltip',
            position: 'top'
          });
        } else {
          tour.push(
            {
              element: '#csv-simulacao-second-tab',
              intro:
                'Aqui você poderá selecionar um arquivo csv para utilizar como informativo de material e/ou tucagem e gerenciar suas respectivas configurações como: (delimitador, invólucro, escape e mapeamento).',
              scrollTo: 'tooltip',
              position: 'top'
            },
            {
              element: '#switch-banco-precos-csv',
              intro: 'Clicando sobre esse switch você poderá alternar entre importar arquivos referente ao material e tucagem.',
              scrollTo: 'tooltip',
              position: 'top'
            }
          );
        }

        return tour;
      },

      arrTerceiraTabTour() {
        return [
          {
            element: '#tipologia-anel-simulacao',
            intro:
              'Aqui você deverá informar os percentuais ou selecionar um cálculo de Saneamento do VOC para cada Tipologia ANEEL .',
            scrollTo: 'tooltip',
            position: 'right'
          }
        ];
      }
    },

    created() {
      this.$store.dispatch('clearSimulacaoLaudoIncremental');

      if (this.$route.params.id) this.getById(this.$route.params.id);

      this.iniciarPrimeiraTabTour();
    },

    methods: {
      getById(id) {
        SimulacoesLaudosIncrementaisService.getById(id)
          .then((response) => {
            this.setDataInVuex(response.data.data);
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar a Simulação do Laudo Express.', '', { position: 'topRight' });
          });
      },

      save() {
        const data = this.$refs.wizzardTabsREF.exportData();
        this.loading = true;

        // if (data.calculo_com_ca_aneel_id == null) {
        //   this.$toast.error('Selecione ao menos um Saneamento do VOC.', '', {
        //     position: 'topRight'
        //   });

        //   this.loading = false;
        //   return;
        // }

        SimulacoesLaudosIncrementaisService.salvar(data)
          .then(() => {
            this.$toast.success('Simulação do Laudo Express salvo com sucesso.', '', { position: 'topRight' });
            this.$router.replace({ name: 'Simulacoes Laudos Express Historico' });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao salvar Simulação do Laudo Express.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },

      setDataInVuex(item) {
        this.$store.dispatch('setSimulacaoLaudoIncremental', {
          /* Campos etapa 1 */
          titulo: item.titulo,
          possuiObra: item.possui_obra,
          possuiMaterial: item.possui_material,
          depreciaMes: item.deprecia_mes,
          vlrAlmoxarifado: item.vlr_almoxarifado_em_operacao,
          origemDadosAis: item.origem_dados_ais,
          aisDataBase: this.getOnlyDateIgnoringTimestamp(item.data_base),
          dataImobilizacaoInicio: this.getOnlyDateIgnoringTimestamp(item.data_imobilizacao_inicio),
          dataImobilizacaoFim: this.getOnlyDateIgnoringTimestamp(item.data_imobilizacao_fim),
          dataSimulacaoLaudo: this.getOnlyDateIgnoringTimestamp(item.data_simulacao_laudo),
          arquivoBaseContabil: item.arquivo_base_contabil_id
            ? {
                id: item.arquivo_base_contabil_id,
                fileObj: new File([''], item.arquivo_base_contabil.arquivo, {
                  type: 'text/csv'
                }),
                delimitador: item.arquivo_base_contabil_delimitador,
                involucro: item.arquivo_base_contabil_involucro,
                escape: item.arquivo_base_contabil_escape
              }
            : undefined,
          arquivoRosVal: item.arquivo_ros_val_id
            ? {
                id: item.arquivo_ros_val_id,
                fileObj: new File([''], item.arquivo_ros_val.arquivo, {
                  type: 'text/csv'
                }),
                delimitador: item.arquivo_ros_val_delimitador,
                involucro: item.arquivo_ros_val_involucro,
                escape: item.arquivo_ros_val_escape
              }
            : undefined,
          arquivoIa: item.arquivo_ia_id
            ? {
                id: item.arquivo_ia_id,
                fileObj: new File([''], item.arquivo_ia.arquivo, {
                  type: 'text/csv'
                }),
                delimitador: item.arquivo_ia_delimitador,
                involucro: item.arquivo_ia_involucro,
                escape: item.arquivo_ia_escape
              }
            : undefined,
          arquivoObrigacoesEspeciais: item.arquivo_obrigacoes_especiais_id
            ? {
                id: item.arquivo_obrigacoes_especiais_id,
                fileObj: new File([''], item.arquivo_obrigacoes_especiais.arquivo, {
                  type: 'text/csv'
                }),
                delimitador: item.arquivo_obrigacoes_especiais_delimitador,
                involucro: item.arquivo_obrigacoes_especiais_involucro,
                escape: item.arquivo_obrigacoes_especiais_escape
              }
            : undefined,

          /* Campos etapa 2 */
          origemDadosBancoPrecos: item.origem_dados_banco_precos,
          bancoPrecos: {
            id: item.banco_preco_calculo_id,
            nome: item.banco_preco_calculo_id ? `#${item.banco_preco_calculo_id} - ${item.banco_preco_calculo.titulo}` : ''
          },
          bancoPrecosMateriais: item.banco_precos_materiais,
          bancoPrecosTucagens: item.banco_precos_tucagens,
          infoUploadedFileMaterial: {
            id: item.banco_precos_materiais_arquivo_id,
            delimitador: item.banco_precos_materiais_delimitador,
            involucro: item.banco_precos_materiais_involucro,
            escape: item.banco_precos_materiais_escape,
            mapeamento: item.banco_precos_materiais_mapeamento_arquivo
              ? JSON.parse(item.banco_precos_materiais_mapeamento_arquivo)
              : { CODIGO_MATERIAL: '', VALOR_UNITARIO: '' },
            needToUploadFakeFile:
              this.$route.params.id && item.banco_precos_materiais && item.banco_precos_materiais_arquivo_id ? true : false
          },
          infoUploadedFileTucagem: {
            id: item.banco_precos_tucagens_arquivo_id,
            delimitador: item.banco_precos_tucagens_delimitador,
            involucro: item.banco_precos_tucagens_involucro,
            escape: item.banco_precos_tucagens_escape,
            mapeamento: item.banco_precos_tucagens_mapeamento_arquivo
              ? JSON.parse(item.banco_precos_tucagens_mapeamento_arquivo)
              : {
                  TUC: '',
                  A1: '',
                  A2: '',
                  A3: '',
                  A4: '',
                  A5: '',
                  A6: '',
                  VALOR_UNITARIO: ''
                },
            needToUploadFakeFile:
              this.$route.params.id && item.banco_precos_tucagens && item.banco_precos_tucagens_arquivo_id ? true : false
          }
        });

        let percentuais = JSON.parse(item.percentuais);

        /* Campos etapa 3 */
        this.$store.dispatch('setSimulacaoLaudoIncremental', {
          arquivoPercSaneamentoObra: item.arquivo_perc_saneamento_obra_id
            ? {
                id: item.arquivo_perc_saneamento_obra_id,
                fileObj: new File([], item.arquivo_perc_saneamento_obra.arquivo, { type: 'text/csv' }),
                delimitador: item.arquivo_perc_saneamento_obra_delimitador,
                involucro: item.arquivo_perc_saneamento_obra_involucro,
                escape: item.arquivo_perc_saneamento_obra_escape
              }
            : undefined,
          saneamentoVoc:
            item.calculo_com_ca_aneel_id != null
              ? {
                  nome_calculo: `#${item.calculo_com_ca_aneel.id} - ${item.calculo_com_ca_aneel.nome}`,
                  saneamento_voc_id: item.calculo_com_ca_aneel_id
                }
              : {
                  nome_calculo: null,
                  saneamento_voc_id: null
                },
          percentuais: percentuais,
          desconsiderarExcecoes: JSON.parse(item.excecoes_saneamento)
        });

        this.$forceUpdate();
      },

      iniciarPrimeiraTabTour() {
        this.doneLabel = 'Proximo';
        this.desativarTourAoSair = false;
        let onBeforeExitFunction = {
          func: () => {
            this.tab = 1;
            this.iniciarSegundaTabTour();
          }
        };
        this.iniciarTour(this.arrPrimeiraTabTour, [], [], [onBeforeExitFunction]);
      },

      iniciarSegundaTabTour() {
        let onBeforeExitFunction = {
          func: () => {
            this.tab = 2;
            this.iniciarTerceiraTabTour();
          }
        };
        this.iniciarTour(this.arrSegundaTabTour, [], [], [onBeforeExitFunction]);
      },

      iniciarTerceiraTabTour() {
        this.doneLabel = 'Finalizar';
        this.desativarTourAoSair = true;
        let onBeforeExitFunction = { func: () => (this.tab = 0) };

        this.iniciarTour(this.arrTerceiraTabTour, [], [], [onBeforeExitFunction]);
      }
    }
  };
</script>
